import { VFC } from "react";

import { TextInput } from "@portex-pro/ui-components";
import Text from "components/Text";
import { useShipmentDetails } from "features/shipments/provider/ShipmentDetailsProvider";
import { Trans } from "react-i18next";

const InternalReferenceNumber: VFC = () => {
  const { patch, patchedShipment } = useShipmentDetails();

  return (
    <div>
      <Text size="medium" typographyProps={{ style: { marginBottom: "8px" } }}>
        <Trans
          i18nKey="shipmentDetailsStep.internalReferenceNumberOptional"
          ns="shipper"
          components={[<strong></strong>]}
        />
      </Text>
      <TextInput
        fullWidth
        value={patchedShipment.internalReferenceNumber}
        onChange={(ev) => patch({ internalReferenceNumber: ev.target.value })}
      />
    </div>
  );
};

export default InternalReferenceNumber;
